import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { RegionProvider } from "../../shared/providers/region.provider";
import { ChannelProvider } from "../../shared/providers/channel.provider";
import { GeographyProvider } from "../../shared/providers/geography.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';


@Component({
  selector: 'app-create-visits',
  templateUrl: './create-visits.component.html',
  styleUrls: ['./create-visits.component.scss']
})
export class CreateVisitsComponent implements OnInit {

  regions: any = [];
  geography: any = [];
  channels: any = [];
  tseData: any = [];
  formData: any = {};
  formatedTseData: any = [];
  filteredDetails: any = { tse: [] };
  formatedExcelData: any = []
  outletList: any = [];
  hideImportBtn: boolean = true;
  hideVisitTable: boolean = true;
  taskId: any;
  campaigns: any = [];
  tasks: any = [];
  filterData: any = {
    region_id: '',
    geographical_id: '',
    channel_id: '',
  };
  //all disabled actions can be controlled from this object
  disable = {
    campaignInput: true,
    taskInput: true,
    findTseButton: true,
  }


  constructor(
    private xls: XlsxService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    public adminDataProvider: AdminDataProvider,
    public regionProvider: RegionProvider,
    public channelProvider: ChannelProvider,
    public geographyProvider: GeographyProvider,
  ) { }

  public headers;
  public columns;
  public start_date;
  public end_date;
  public beats = [];
  public save = true;
  public failed;
  public notice = false;
  public sampleData = [{ OUTLET: "", TSE: "", visit_date: "" }];

  ngOnInit() {

  }

  ngDoCheck() {
    this.regions = this.regionProvider.regions;
    this.geography = this.geographyProvider.geography;
    this.channels = this.channelProvider.channels;
  }

  //find campaings based on filter params
  findCampaings() {
    console.log(this.filterData.geographical_id, this.filterData.channel_id, this.filterData.region_id)
    this.apiService.post(this.apiConfig.getCampaingsBasedOnFilter, this.filterData)
      .subscribe((res: any) => {
        this.campaigns = res.body.data.campaigns
        if (this.campaigns.length > 0) {
          this.disable.campaignInput = false
        } else {
          this.toast.Error('No campaigns found')
        }
      }, err => {
        console.log(err)
      });
  }

  getCampaignTasks(id){
    this.formData.campaign_id = id;
    this.apiService.get(this.apiConfig.getTasksBasedOnCampaign + id)
    .subscribe((res:any)=>{
      this.tasks = res.data.tasks
      console.log(this.tasks);
      if (this.tasks.length > 0) {
        this.disable.taskInput = false
      } else {
        this.toast.Error('No tasks found')
      }
    },err=>{
      console.log(err)
    });
    
  }
  
  taskSelected(id){
    this.taskId = id;
    this.formData.task_id = this.taskId;

    this.disable.findTseButton = false
  }

  findMappedTse(){
    this.apiService.get(this.apiConfig.getVtTseList + this.taskId)
    .subscribe((res:any)=>{
    this.tseData = res.data.tse_details;
    if(this.tseData.length > 0){
      this.formatfilterData();
    }else{
      this.toast.Error('No TSE mapped to this task')
    }
    },err=>{
    console.log(err)
    });
  }


  // we format the data before passing it to the multiselect dropdown
  // since the key names have to be different
  formatfilterData() {
    let data = {
      id: '',
      name: ''
    }
    this.tseData.forEach(tse => {
      data.id = tse.id;
      data.name = tse.user_detail_name;
      this.formatedTseData.push(JSON.parse(JSON.stringify(data)));
    });
  }

  //put data into the excel according the required format and download it
  sortExcelBasedOnResult() {

    let excelDataFormat = {
      TSE: '',
      OUTLET: '',
      visit_date: '',
    }
    //Map and format the array in the format required in the excel
    this.tseData.forEach(tse => {
      if(tse.user_outlets.length > 0){
        tse.user_outlets.forEach(outlets =>{
          excelDataFormat.TSE = tse.contact_no;
          excelDataFormat.OUTLET = outlets.contact_no;
          this.formatedExcelData.push(JSON.parse(JSON.stringify(excelDataFormat)));
        })
      }
    });

    // download the excel after populating all the data
    this.xls.export(this.formatedExcelData, 'VisitData').then((res) => {
      if (res != null) {
        this.toast.Success("Sample Downloaded")
      } else {
        this.toast.Error("err")
      }
    })

    //show import button
    this.hideImportBtn = false;
  }

  importExcel(event) {
    this.xls.uploadXlsx(event)
      .then((res: any) => {
        this.headers = res.headers;
        this.columns = res.data;
        this.save = false;
        this.notice = false;
        this.hideVisitTable = false;
      })
  }

  submit() {
    
    this.beats.push({ "beats": this.columns })
    this.formData.visits = JSON.stringify(this.beats);
    this.formData.program_id = 1;

    if (this.formData.visit_beat_name == undefined || this.formData.visit_points == undefined) {
      this.toast.Error('Enter all required fields');
      return
    }
    this.apiService.postWithFormData(this.apiConfig.createVisits, this.formData)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toast.Success("Import Success")
          this.notice = true;
          this.failed = res.data.failed_data.length
        }
      })
  }

  //GET ALL SELECTED TSE ID's
  formateFillters(data, name) {
    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1)
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach(element => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }
}
